import { render, staticRenderFns } from "./TaskListOrderPop.vue?vue&type=template&id=464c26d6&"
import script from "./TaskListOrderPop.vue?vue&type=script&lang=js&"
export * from "./TaskListOrderPop.vue?vue&type=script&lang=js&"
import style0 from "./TaskListOrderPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports